export const SPEED_OF_ME_API_KEY = 'SOM61394bb061e13';
export const SPEED_OF_ME_DEV_API_KEY = 'INVALID_SPEED_OF_ME_KEY';
